<template>
  <div>
    <DataByIndustry v-if="gbType!=='2'"/>
    <DataBySaler v-else/>

    <h2 class="text-center p-t-20 p-b-10">行业签约额分布</h2>
    <div style="width:100%;height:180px;" id="kpiRightReport"></div>
    <Row class="table-title p-l-10 p-r-10 m-t-5" :gutter="8">
      <i-col span="8">行业</i-col>
      <i-col span="10" class="text-right">签约额</i-col>
      <i-col span="6" class="text-right">占比</i-col>
    </Row>
    <Row v-for="(item,index) in contractListByIndustry" :key="index" :gutter="8" class="p-t-5 p-l-10 p-r-10">
      <i-col span="8">{{item.name}}</i-col>
      <i-col span="10" class="text-right">{{formatMoney(item.value)}}</i-col>
      <i-col span="6" class="text-right">{{item.rate}}%</i-col>
    </Row>
    <div v-show="showArray.length>currentPageSize" class="paging_style">
      <Page size="small" :total="showArray.length" :page-size="currentPageSize" :current="currentPageNumber" @on-change="handlePageChange"></Page>
    </div>
    <p v-if="contractListByIndustry.length===0" class="remark p-t-20 text-center">暂无数据</p>

  </div>
</template>

<script>
import DataByIndustry from '../rightComponents/DataByIndustry'
import DataBySaler from '../rightComponents/DataBySaler'

import * as echarts from 'echarts'
import { toMoney } from '@/utils/wnumb_own'
import { listContractAmountGbIndustry } from '@/api/dw/kpi'

export default {
  components: {
    DataByIndustry, DataBySaler
  },
  data () {
    return {
      publisherId: this.$store.getters.token.userInfo.publisherId,

      contractListByIndustry: [],
      showArray: [],
      currentPageSize: 8,
      currentPageNumber: 1,
      dataSourcePie: null
    }
  },
  created () {
    this.loadContractAmountGbIndustry()
  },
  methods: {
    loadContractAmountGbIndustry () {
      const queryModel = {
        publisherId: this.publisherId,
        companyId: this.companyId,
        startDate: this.searchSchedule.startDate,
        endDate: this.searchSchedule.endDate,
        industryGroupId: this.gbType !== '2' ? this.gbId : null,
        userId: this.gbType === '2' ? this.gbId : null
      }

      listContractAmountGbIndustry(queryModel).then(res => {
        this.showArray = res
        this.handlePageChange(1)

        const reportData = res.map(element => {
          return {
            value: element.rate,
            name: element.name
          }
        })
        this.initChartReport(reportData)
      })
    },
    handlePageChange (page) {
      this.currentPageNumber = page
      const newArray = []
      for (let index = this.currentPageSize * (page - 1); index < this.currentPageSize * page; index++) {
        if (index < this.showArray.length) {
          newArray.push(this.showArray[index])
        } else {
          break
        }
      }

      this.contractListByIndustry = newArray
    },
    formatMoney (number) {
      return toMoney(number)
    },
    initChartReport (reportData) {
      if (this.dataSourcePie != null && this.dataSourcePie !== '' && this.dataSourcePie !== undefined) {
        this.dataSourcePie.dispose()
      }

      this.$nextTick(() => {
        // 防止页面被切换，元素被移除
        if (document.getElementById('kpiRightReport')) {
          this.dataSourcePie = echarts.init(document.getElementById('kpiRightReport'))
          const option = {
            tooltip: {
              trigger: 'item'
            },
            series: [
              {
                name: '行业签约额分布',
                type: 'pie',
                radius: ['70%', '90%'],
                avoidLabelOverlap: false,
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: '15',
                    formatter: '{d}%\n{b}',
                    color: '#fff'
                  }
                },
                labelLine: {
                  show: false
                },
                data: reportData
              }
            ]
          }

          this.dataSourcePie.setOption(option, true)
          const that = this
          window.addEventListener('resize', function () {
            that.dataSourcePie.resize()
          })

          // 默认选中第一项
          let index = 0
          const _self = this
          _self.dataSourcePie.dispatchAction({
            type: 'highlight',
            seriesIndex: 0,
            dataIndex: 0
          }) // 设置默认选中高亮部分
          _self.dataSourcePie.on('mouseover', function (e) {
            if (e.dataIndex !== index) {
              _self.dataSourcePie.dispatchAction({
                type: 'downplay',
                seriesIndex: 0,
                dataIndex: index
              })
            }
          })
          _self.dataSourcePie.on('mouseout', function (e) {
            index = e.dataIndex
            _self.dataSourcePie.dispatchAction({
              type: 'highlight',
              seriesIndex: 0,
              dataIndex: e.dataIndex
            })
          })
        }
      })
    }
  },
  computed: {
    searchSchedule () {
      return this.$store.state.situationWeb.searchSchedule
    },
    companyId () {
      return this.$store.state.situationWeb.companyId
    },
    gbId () {
      return this.$store.state.situationWeb.gbId
    },
    gbType () {
      return this.$store.state.situationWeb.gbType
    }
  },
  watch: {
    searchSchedule: {
      deep: true,
      handler (newValue) {
        this.loadContractAmountGbIndustry()
      }
    },
    companyId () {
      this.loadContractAmountGbIndustry()
    },
    gbType () {
      this.loadContractAmountGbIndustry()
    },
    gbId () {
      this.loadContractAmountGbIndustry()
    }
  }
}
</script>

<style>

</style>
